import { render, staticRenderFns } from "./OffDayTypeSelector.vue?vue&type=template&id=6f0f6f66&"
import script from "./OffDayTypeSelector.vue?vue&type=script&lang=js&"
export * from "./OffDayTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports